"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let Numbering = class Numbering extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    oid;
    onOid(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("oid");
    }
    objectType;
    onObject_type(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("objectType");
    }
    createParams;
    onCreate_params(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("createParams");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    resourceTypes;
    item;
    async $$load_item() {
        return this.oid
            ? this.$fn.fetch('read_numbering', { parameters: { id: this.oid }, asResource: true })
            : this.$fn.schemaDefaults('CreateNumbering', _.extend({
                resource_type: this.objectType,
                start: 1,
                increment: 1,
                variables: []
            }, this.createParams));
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    ux;
    b_7315092382398562_modalBindings;
    b_3083451129821185_paging;
    b_3083451129821185_columns;
    dataMembers = ['resourceTypes', 'item', 'formId', 'ux', 'b_7315092382398562_modalBindings', 'b_3083451129821185_paging', 'b_3083451129821185_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                resourceTypes: ["account",
                    "contract",
                    "dunning_letter",
                    "fixed_asset",
                    "invoice:out",
                    "invoice:in",
                    "part",
                    "product",
                    "rental",
                    "rental_contract",
                    "worksheet",
                ],
                item: null,
                formId: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "lg",
                },
                b_3083451129821185_paging: false,
                b_3083451129821185_columns: [{
                        name: "id",
                        header: this.$fn.pgettext("Numbering", "ID"),
                        width: "120px",
                        required: true,
                    },
                    {
                        name: "name",
                        header: this.$fn.pgettext("Numbering", "Name"),
                        width: "120px",
                        required: true,
                    },
                    {
                        name: "data_type",
                        header: this.$fn.pgettext("Numbering", "Data type"),
                        width: "120px",
                        required: true,
                    },
                    {
                        name: "value",
                        header: this.$fn.pgettext("Numbering", "Value"),
                        width: "120px",
                        required: true,
                    },
                ],
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.oid == null ? this.$fn.gettext("New Numbering") : this.item.snapshot("key"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_3632_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_3638_getActionArgs($event) {
        return {
            result: {
                close: true,
                ok: true,
                value: $event.data,
            },
        };
    }
    async act_1040167445267876_crud_3636_getActionArgs($event) {
        return {
            objectType: "numbering",
            op: "upsert",
            data: this.item,
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_1419464017721962_closeModal_3640_getActionArgs($event) {
        return {
            name: this.modalName,
        };
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_3632 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_3632_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_3631 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_3632,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_3631],
        });
        const act_2248226175642056_closeComponent_3634 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_3633 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_3634,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_3633],
        });
        const act_1040167445267876_closeModal_3638 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_3638_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_3637 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_3638,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_crud_3636 = new core_1.actions.CRUDAction({
            actionArgs: this.act_1040167445267876_crud_3636_getActionArgs,
            displayName: "submit",
            events: [evh_1040167445267876_success_3637],
        });
        const evh_1040167445267876_submit_3635 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_crud_3636,
            event: "submit",
            displayName: "submit",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_3635],
        });
        const act_1419464017721962_closeModal_3640 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1419464017721962_closeModal_3640_getActionArgs,
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_3639 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeModal_3640,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_3639],
        });
        return {
            act_7315092382398562_closeModal_3632,
            evh_7315092382398562_close_3631,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_3634,
            evh_2248226175642056_close_3633,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_3638,
            evh_1040167445267876_success_3637,
            act_1040167445267876_crud_3636,
            evh_1040167445267876_submit_3635,
            evh_1040167445267876_submit,
            act_1419464017721962_closeModal_3640,
            evh_1419464017721962_clickPreventStop_3639,
            evh_1419464017721962_clickPreventStop,
            submit: act_1040167445267876_crud_3636,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: null,
    }),
    __metadata("design:type", String)
], Numbering.prototype, "oid", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('oid'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Numbering.prototype, "onOid", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: null,
    }),
    __metadata("design:type", String)
], Numbering.prototype, "objectType", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('objectType'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Numbering.prototype, "onObject_type", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
        default: null,
    }),
    __metadata("design:type", Object)
], Numbering.prototype, "createParams", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('createParams'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Numbering.prototype, "onCreate_params", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], Numbering.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Numbering.prototype, "onSize", null);
Numbering = __decorate([
    (0, vue_property_decorator_1.Component)()
], Numbering);
exports.default = Numbering;
vue_property_decorator_1.Vue.component("Numbering", Numbering);
